import FormatePrice from '../utils/FormatePrice';
import Drawer from '@mui/joy/Drawer';
import ModalClose from '@mui/joy/ModalClose';
import { toast } from 'react-toastify';
import { TransactionId } from '../services/transactionService';
import { useEffect, useState } from 'react';
import { FormateDate } from '../utils/FormateDate';
import { TransactionStatus } from '../utils/Enums';


const TransactionDetails = ({ isOpen, onClose, id }) => {
  const [loading, setLoading] = useState(false);
  const [transactionDetails, setTransactionDetails] = useState(null);

  useEffect(() => {
    const fetchTransactionDetails = async () => {
        setLoading(true)
        try {
        const response = await TransactionId(id);
        setTransactionDetails(response?.data);
        } catch (error) {
        console.error("Error fetching Agent details:", error);
        toast.error("Failed to load Agent details.");
        } finally {
        setLoading(false);
        }
    }
    fetchTransactionDetails();
  }, [id]);

  return (
    <Drawer anchor="right" open={isOpen} onClose={onClose} size="md"
      slotProps={{
        root: {
          className: `
            backdrop-blur-[1px] 
            bg-orange/20 
            rounded-tl-2xl 
          `,
        },
      }}  
    >
      <ModalClose />
      <div className="p-5">
          <h3 className="capitalize text-[24px] font-bold text-primaryRed mt-5">Transaction Details</h3>

          <p className="my-2 text-foreground text-sm text-[#0A0A0ACC]">
          Review full transaction details, payment status, and timing to stay informed on order progress.
          </p>
          <div className="mt-4 space-y-4">
            <div className="mt-4 rounded-lg border px-3">
              <div className="flex justify-between items-center mt-3">
                <p className="text-xs text-[#0A0A0A] opacity-80">Transaction ID</p>
                <p className="text-xs font-medium">{transactionDetails?.paymentHistoryDetails?.reference}</p>
              </div>
              <div className="h-[1px] w-full border-0 bg-primaryGray my-1" />
              <div className="flex justify-between items-center mt-3">
                <p className="text-xs text-[#0A0A0A] opacity-80">Date</p>
                {transactionDetails?.paymentHistoryDetails?.date && 
                <p className="text-xs font-medium">{FormateDate(transactionDetails?.paymentHistoryDetails?.date)}</p>
                }
              </div>
              <div className="h-[1px] w-full border-0 bg-primaryGray my-1" />
              <div className="flex justify-between items-center mt-3">
                <p className="text-xs text-[#0A0A0A] opacity-80">Type</p>
                  <p className="text-xs font-medium">{TransactionStatus[transactionDetails?.paymentHistoryDetails?.paymentStatus]}</p>
              </div>
              <div className="h-[1px] w-full border-0 bg-primaryGray my-1" />
              <div className="flex justify-between items-center mt-3">
                <p className="text-xs text-[#0A0A0A] opacity-80">Amount</p>
                  <p className="text-xs font-medium">+{FormatePrice(transactionDetails?.paymentHistoryDetails.amount)}</p>
              </div>
              <div className="h-[1px] w-full border-0 bg-primaryGray my-1" />
              <div className="flex justify-between items-center mt-3">
                <p className="text-xs text-[#0A0A0A] opacity-80">Status</p>
                  <p className="text-xs font-medium bg-[#008000] px-3 py-2 text-white rounded-md">{transactionDetails?.paymentHistoryDetails.type}</p>
              </div>
              <div className="h-[1px] w-full border-0 bg-primaryGray my-1" />
            </div>
            <div className="mt-10 rounded-lg border px-3 pb-4">
              <div className="flex justify-between items-center mt-3">
                <p className="text-xs text-[#0A0A0A] opacity-80">Related Entity</p>
                <p className="text-xs font-medium">{transactionDetails?.entityDetails?.orderCode}</p>
              </div>
              <div className="h-[1px] w-full border-0 bg-primaryGray my-1" />
              <div className="flex justify-between items-center mt-3">
                <p className="text-xs text-[#0A0A0A] opacity-80">Agent Involved</p>
                <p className="text-xs font-medium">{transactionDetails?.entityDetails?.agentName}</p>
              </div>
              <div className="h-[1px] w-full border-0 bg-primaryGray my-1" />
              <div className="flex justify-between items-center mt-3">
                <p className="text-xs text-[#0A0A0A] opacity-80">Customer Feedback</p>
                  <p className="text-xs font-medium">Excellent service</p>
              </div>
              <div className="h-[1px] w-full border-0 bg-primaryGray my-1" />
              <div className="flex justify-between items-center mt-3 gap-5">
                <p className="text-xs text-[#0A0A0A] opacity-80">Description</p>
                <p className="text-xs font-medium grid place-items-end">{transactionDetails?.entityDetails?.description}</p>
              </div>
              <div className="h-[1px] w-full border-0 bg-primaryGray my-1" />
            </div>
            <div className="flex items-center gap-10 justify-between mt-4">
              <button 
                onClick={onClose}
                className="text-primaryRed hover:bg-opacity-50 rounded-md py-2 bg-white w-full outline-none ring-0 border border-primaryRed hover:bg-primaryRed hover:text-white hover:outline-none capitalize mt-6 focus:outline-none"
              >Cancel </button>
              <button
                className="bg-[#FF0000] hover:bg-opacity-50 rounded-md py-2 text-white w-full outline-none ring-0 border border-primaryRed hover:bg-white hover:text-primaryRed hover:outline-none capitalize mt-6 focus:outline-none"
              >Save </button>
            </div>
          </div>
        </div>
    </Drawer>
  );
}

export default TransactionDetails;